import { LocalizedText, useDialogAction } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { PortfolioEnterpriseGroupResult } from '@mews-commander/data-access';
import { Button } from '@optimus-web/core';
import { EditPropertyGroupContainer } from './EditPropertyGroupContainer';

interface EditPropertyGroupWrapperProps {
    selectedPropertyGroup: PortfolioEnterpriseGroupResult;
}

export const EditPropertyGroupWrapper = ({ selectedPropertyGroup }: EditPropertyGroupWrapperProps) => {
    const { states, handlers } = useDialogAction(async () => Promise.resolve());

    return (
        <>
            <Button
                variant="primary"
                onClick={() => {
                    handlers.handleOpen();
                }}
                type="submit"
            >
                <LocalizedText textKey={TextKey.Edit} />
            </Button>
            {states.isDialogOpened && (
                <EditPropertyGroupContainer
                    isOpened={states.isDialogOpened}
                    onCancel={handlers.handleCancel}
                    onConfirm={handlers.handleConfirm}
                    onSuccess={handlers.handleConfirm}
                    selectedPropertyGroup={selectedPropertyGroup}
                />
            )}
        </>
    );
};
